import EmptyList from '@/components/Common/EmptyList';
import SurveyChartsSearchPanel from './SurveyChartsSearchPanel';
import SurveyChartsChart from './SurveyChartsChart';
import {randomColor} from '../../../utils/helpers';


// @vue/component
export default {
    name: 'SurveyCharts',

    components: {
        SurveyChartsSearchPanel,
        SurveyChartsChart,
        EmptyList
    },
    async created() {
        this.$store.dispatch('campaign/clearSurveyAnswers');
    },
    methods: {
        getRandomColor(){
            return randomColor(150);
        },
        getPercentage(count,sum){
            const percentage = ((count / sum) * 100).toFixed(2);
            return `${percentage}%`;
        },
        formatAnswer(answer){
            let formatedAnswer = '';
            if(answer === "true"){
                formatedAnswer = 'Tak';
            }else if(answer === "false"){
                formatedAnswer = "Nie";
            }else if(answer === ""){
                formatedAnswer = "Brak odpowiedzi";
            }
            else{
                formatedAnswer = answer;
            }
            return formatedAnswer;
        }
    },
    computed: {
        surveyResultsList() {
            return this.$store.getters['campaign/surveyResultslist'];
        },
        surveyUuidsForFiltering() {
            const uniqueUuids = new Set();
            const unique = this.surveyResultsList.records.filter(element => {
                const isDuplicate = uniqueUuids.has(element._survey_uuid);
                uniqueUuids.add(element._survey_uuid);
                return !isDuplicate ? true : false;
            });
            return unique.map(item => ({ name: item._survey_name, uuid: item._survey_uuid }));
        },
        surveyAnswers() {
            return this.$store.getters['campaign/surveyAnswers'];
        },
        surveyAnswersDataSet(){
            return this.surveyAnswers.map(question => {
                return {
                    id: question.question_id,
                    question: question.question,
                    chartData: {
                    labels: question.answers.map(answer => `${this.formatAnswer(answer.answer)} (${answer.count} [${this.getPercentage(answer.count,question.answers_sum)}])`),
                    datasets: [{
                        label: 'Odpowiedzi',
                        backgroundColor: question.answers.map(() => this.getRandomColor()),
                        data: question.answers.map(answer => answer.count)
                    }],
                }
                }
            });
        },
        isLoading() {
            return this.$store.getters['global/pendingAsyncStoreActions'].includes([
                'campaign/getSurveyAnswers',
            ]);
        }
}
}